import NotFoundSVG from '@Assets/Images/404.svg';
import styles from './NotFound.module.scss';

const NotFound = () => (
  <div className={styles['not-found']}>
    <img src={NotFoundSVG} alt='Not Found' className='ac2-not-found-img' />
    <h1 className='ac2-error-title'>Page Not Found</h1>
    <h2 className='ac2-error-subtitle'>Sorry, the page you are looking for does not exist.</h2>
  </div>
);
export default NotFound;
